import { Packer } from 'docx';
import { saveAs } from 'file-saver';
import { DocumentCreator } from './previewSubmission';
import processTextBody from './processTextBody';

export const fetchImageByPath = async (figurePath) => {
    const imageWidth = 600;
    const token = localStorage.getItem('accessToken');
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';

    // Use native fetch with a timeout — avoids axios interceptor issues with blob responses
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);

    let response;
    try {
        response = await fetch(`${baseUrl}/api/prv/submissions/${figurePath}`, {
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal,
        });
    } finally {
        clearTimeout(timeout);
    }

    if (!response.ok) {
        throw new Error(`Figure fetch failed: ${response.status}`);
    }

    const arrayBuffer = await response.arrayBuffer();
    const blobImage = new Blob([arrayBuffer], { type: response.headers.get('content-type') || 'application/octet-stream' });
    const imageUrl = URL.createObjectURL(blobImage);
    const img = new Image();
    img.src = imageUrl;

    return new Promise((resolve, reject) => {
        img.onload = () => {
            const imageHeight = Math.round((img.height / img.width) * imageWidth);
            URL.revokeObjectURL(imageUrl);
            resolve({ imageWidth, imageHeight, blobImage });
        };
        img.onerror = () => {
            URL.revokeObjectURL(imageUrl);
            reject(new Error(`Failed to load image: ${figurePath}`));
        };
    });
};

export const downloadPreview = async (abstract) => {
    const dataBody = processTextBody(abstract.type.structures, abstract.body);
    const documentCreator = new DocumentCreator();
    let imageWidth;
    let imageHeight;
    let blobImage;

    if (abstract.data?.figure?.fileUrl) {
        try {
            const result = await fetchImageByPath(abstract.data.figure.fileUrl);
            imageWidth = result.imageWidth;
            imageHeight = result.imageHeight;
            blobImage = result.blobImage;
        } catch {}
    }

    const doc = documentCreator.create([
        abstract.title,
        dataBody,
        abstract.data.keyword,
        blobImage,
        imageWidth,
        imageHeight,
        abstract.authors,
        abstract.data?.figure?.caption,
    ]);

    const abstractTitle = abstract.title ? `- ${abstract.title}` : '';
    const fileName = `Abstract - ${abstract.user.fullName}${abstractTitle}.docx`;
    const blob = await Packer.toBlob(doc);

    saveAs(blob, fileName);
};

export default downloadPreview;
